
import { useEffect, useState } from "react";
import Packky from "../../assets/Packky.png";
import { Link, useNavigate } from "react-router-dom";
import { Instagram, Facebook, Linkedin, ArrowUp } from "lucide-react";


const Footer = () => {
  const navigate = useNavigate();

  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollTop = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", updateScrollProgress);
    return () => window.removeEventListener("scroll", updateScrollProgress);
  }, []);

  return (
    <div className="footer-container">
      <footer className="footer relative text-gray-800">
        <div className="mx-auto w-full max-w-7xl px-4">
          <div className="flex flex-wrap items-start">
            {/* LEFT */}
            <div className="w-full md:w-1/3 text-center md:text-left">
              <div
                className="flex justify-center md:justify-start"
                onClick={() => navigate("/")}
              >
                <img
                  src={Packky}
                  alt="Logo"
                  className="mt-4 h-auto max-w-full"
                  style={{ maxWidth: "150px" }}
                />
              </div>

              <p className="card-text font-sf mt-3 !text-[18px] text-center md:text-left">
                Order anything and track it in real time with the Packky
                (powered by Chaafo) app
              </p>
            </div>

            {/* CENTER */}
            <div className="mt-6 w-full md:mt-4 md:w-1/3 flex justify-center">
              <div className="flex flex-col items-center md:items-start text-center md:text-left">
                {[
                  { label: "About us", link: "/about-us" },
                  { label: "Contact Us", link: "/contact-us" },
                  { label: "Term & Condition", link: "/term-condition" },
                  { label: "Privacy Policy", link: "/privacy-policy" },
                  { label: "Delete Account", link: "/delete-account" },
                  { label: "Blog", link: "/blog-section" },
                ].map((item, i) => (
                <div
  key={i}
  onClick={() => navigate(item.link)}
  className="mb-2 cursor-pointer text-[16px] font-sf text-gray-800"
>
  {item.label}
</div>
                ))}
              </div>
            </div>

            {/* RIGHT */}
            <div className="mt-6 flex w-full flex-col items-center justify-center md:w-1/3 md:items-start lg:mt-4">
              <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 md:justify-start">
                {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                  <div
                    key={i}
                    className="flex h-[36px] w-[36px] items-center justify-center rounded-full bg-orange-500 shadow-sm transition hover:scale-105 sm:h-[40px] sm:w-[40px] md:h-[44px] md:w-[44px]"
                  >
                    <Icon className="h-4 w-4 text-white sm:h-5 sm:w-5" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* COPYRIGHT */}
          <div className="mt-6 flex justify-center items-center">
            <p className="card-text font-sf text-center text-base">
              Packky (powered by Chaafo) © 2024 . All rights reserved.
            </p>
          </div>

          {/* SCROLL BUTTON */}
          <div
            className="fixed bottom-4 right-5 z-[99999] flex h-[56px] w-[56px] cursor-pointer items-center justify-center rounded-full p-[5px] shadow-lg transition hover:scale-105"
            style={{
              background: `conic-gradient(#f97316 ${scrollProgress}%, #bfdbfe 0)`,
            }}
            onClick={(e) => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <div className="flex h-full w-full items-center justify-center rounded-full bg-white">
              <ArrowUp
  size={28}
  className="text-orange-500"
/>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;

